import { COMPANY_ROLES, COMPANY_ROLE_LABEL, type CompanyRole } from '~/session/access';

export const COMPANY_ROLE_NOTE =
  'O administrador convida e muda o acesso da equipe; o funcionário só usa o que recebe.';

interface CompanyRolePickerProps {
  value: CompanyRole;
  onChange(role: CompanyRole): void;
  /** Recusa do backend no campo `role` (`RoleExceedsGranter`), quando ela chega. */
  error?: string;
  disabled?: boolean;
}

/**
 * O papel na empresa, com a diferença entre os dois explicada em uma linha. A recusa do papel
 * aparece aqui, logo abaixo das opções, como a de nível aparece em cada módulo.
 */
export function CompanyRolePicker({
  value,
  onChange,
  error,
  disabled = false,
}: CompanyRolePickerProps): JSX.Element {
  return (
    <fieldset className="m-0 border-0 p-0">
      <legend className="p-0 font-mono text-[11px] uppercase tracking-overline text-ink-muted">
        Papel na empresa
      </legend>
      <div className="mt-2 flex gap-1.5">
        {COMPANY_ROLES.map((role) => {
          const isSelected = value === role;
          return (
            <button
              key={role}
              type="button"
              aria-label={`Papel: ${COMPANY_ROLE_LABEL[role]}`}
              aria-pressed={isSelected}
              disabled={disabled}
              onClick={() => onChange(role)}
              className={`${isSelected ? 'rx-chip rx-chip-active' : 'rx-chip'} disabled:opacity-40`}
            >
              {COMPANY_ROLE_LABEL[role]}
            </button>
          );
        })}
      </div>
      {error && (
        <p role="alert" className="mt-1 text-[12px] text-negative">
          {error}
        </p>
      )}
      <p className="mt-2 text-[12px] text-ink-subtle">{COMPANY_ROLE_NOTE}</p>
    </fieldset>
  );
}
